/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconHelp8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M0 4a4 4 0 1 0 8 0 4 4 0 0 0-8 0Zm7 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-4.411-.952c0-.828.684-1.332 1.548-1.332.852 0 1.488.504 1.488 1.248v.024c0 .708-.456.996-.882 1.182l-.108.048c-.144.066-.192.144-.192.318 0 .086-.07.156-.156.156h-.42a.216.216 0 0 1-.216-.216c0-.408.144-.666.522-.834l.108-.048c.36-.162.552-.294.552-.594 0-.324-.276-.54-.696-.54-.432 0-.756.216-.756.624 0 .08-.064.144-.144.144h-.468a.18.18 0 0 1-.18-.18Zm1.458 1.896a.552.552 0 0 0-.57.57c0 .336.246.57.57.57.324 0 .57-.234.57-.57a.552.552 0 0 0-.57-.57Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHelp12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M0 6a6 6 0 1 0 12 0A6 6 0 0 0 0 6Zm10.5 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM3.883 4.572c0-1.242 1.027-1.998 2.322-1.998 1.279 0 2.232.756 2.232 1.872v.036c0 1.062-.683 1.494-1.322 1.773l-.163.072c-.215.099-.287.216-.287.477 0 .13-.105.234-.234.234H5.8a.324.324 0 0 1-.325-.324c0-.612.216-.999.784-1.251l.162-.072c.54-.243.828-.441.828-.891 0-.486-.415-.81-1.045-.81-.647 0-1.133.324-1.133.936 0 .12-.097.216-.216.216h-.702a.27.27 0 0 1-.27-.27Zm2.188 2.844c-.486 0-.856.351-.856.855s.37.855.856.855.855-.351.855-.855-.37-.855-.856-.855Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHelp16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8Zm14 0A6 6 0 1 1 2 8a6 6 0 0 1 12 0ZM5.178 6.096c0-1.656 1.368-2.664 3.096-2.664 1.704 0 2.976 1.008 2.976 2.496v.048c0 1.416-.912 1.992-1.764 2.364l-.216.096c-.288.132-.384.288-.384.636 0 .172-.14.312-.312.312h-.84a.432.432 0 0 1-.432-.432c0-.816.288-1.332 1.044-1.668l.216-.096C9.282 6.864 9.666 6.6 9.666 6c0-.648-.552-1.08-1.392-1.08-.864 0-1.512.432-1.512 1.248 0 .16-.129.288-.288.288h-.936a.36.36 0 0 1-.36-.36Zm2.916 3.792c-.648 0-1.14.468-1.14 1.14 0 .672.492 1.14 1.14 1.14.648 0 1.14-.468 1.14-1.14 0-.672-.492-1.14-1.14-1.14Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHelp20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Zm-9.25 4.243C8.75 13.52 9.3 13 9.993 13c.708 0 1.257.52 1.257 1.243 0 .722-.55 1.257-1.257 1.257a1.228 1.228 0 0 1-1.243-1.257ZM10.225 4.5C8.068 4.5 6.45 5.743 6.45 7.75v.025a.5.5 0 0 0 .5.5h.803c.24 0 .435-.195.435-.435 0-1.123.868-1.722 2.037-1.722 1.138 0 1.887.599 1.887 1.453 0 .809-.42 1.183-1.468 1.663l-.3.134c-.883.39-1.213.974-1.213 1.993v.139a.5.5 0 0 0 .5.5h.738a.5.5 0 0 0 .5-.5v-.034c0-.45.12-.63.48-.794l.299-.135c1.258-.57 2.202-1.318 2.202-2.951v-.09c0-1.723-1.498-2.996-3.625-2.996Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHelp24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Zm-9.25 4.243c0-.723.55-1.243 1.243-1.243.708 0 1.257.52 1.257 1.243 0 .722-.55 1.257-1.257 1.257a1.228 1.228 0 0 1-1.243-1.257ZM12.225 6.5c-2.157 0-3.775 1.243-3.775 3.25v.025a.5.5 0 0 0 .5.5h.803c.24 0 .435-.195.435-.435 0-1.123.868-1.722 2.037-1.722 1.138 0 1.887.599 1.887 1.453 0 .809-.42 1.183-1.468 1.663l-.3.134c-.883.39-1.213.974-1.213 1.993v.139a.5.5 0 0 0 .5.5h.738a.5.5 0 0 0 .5-.5v-.034c0-.45.12-.63.48-.794l.299-.135c1.258-.57 2.202-1.318 2.202-2.951v-.09c0-1.723-1.498-2.996-3.625-2.996Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconHelp = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHelp(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconHelp8 {...iconProps} />;
        case '12':
            return <IconHelp12 {...iconProps} />;
        case '16':
            return <IconHelp16 {...iconProps} />;
        case '20':
            return <IconHelp20 {...iconProps} />;
        case '24':
            return <IconHelp24 {...iconProps} />;
        default:
            return <IconHelp24 {...iconProps} />;
    }
});
